const topics = [
"Introductions & Personal Information \nЗнайомство та розповідь про себе",
"Daily Routines \nЩоденні звички",
"Hobbies & Free Time \nХобі та вільний час",
"Travel & Holidays \nПодорожі та відпустки",
"Food & Cooking \nЇжа та приготування",
"Family & Friends \nСім’я та друзі",
"School & Education \nШкола та освіта",
"Work & Careers \nРобота та кар’єра",
"Shopping & Money \nПокупки та гроші",
"Technology & Social Media \nТехнології та соціальні мережі",
"Movies & TV Shows \nФільми та телешоу",
"Music & Entertainment \nМузика та розваги",
"Sports & Exercise \nСпорт та фізичні вправи",
"News & Current Events \nНовини та події",
"Dreams & Future Plans \nМрії та плани на майбутнє",
"Cultural Differences \nКультурні відмінності",
"Weather & Seasons \nПогода та пори року",
"Health & Wellness \nЗдоров’я та самопочуття",
"Personal Experiences & Stories \nОсобисті історії та досвід",
"If You Could... \nЯкби ти міг(могла)...",
"Books & Reading \nКниги та читання",
"Pets & Animals \nДомашні улюбленці та тварини",
"Environment & Nature \nДовкілля та природа",
"Hometown & Neighborhood \nРідне місто та район",
"Languages & Communication \nМови та спілкування",
"Fashion & Style \nМода та стиль",
"Celebrations & Festivals \nСвята та фестивалі",
"Art & Creativity \nМистецтво та творчість",
"Transportation & Commuting \nТранспорт та поїздки",
"Challenges & Achievements \nВиклики та досягнення",
]

export const TopicData = topics.map((topic, index) => (
    {
        index,
        id: index+1,
        lesson: index+1,
        topic
    }
))